import { generateUrlParams } from "../../utils/generateUrlParams";
const baseUrl = "HigherNationalDiploma";

export const getHigherDiplomaApplication = (rrr) => `${baseUrl}/load-higher-national-diploma-application-form?rrr=${rrr}`;

export const addAndUpdateHigherDiplomaApplication = () => `${baseUrl}/add-or-update-higher-national-diploma-application-form`;

export const addAndUpdateHigherDiplomaProgramme = () => `${baseUrl}/add-or-update-higher-national-diploma-application-programme`;

export const addAndUpdateHigherDiplomaEducation  = () => `${baseUrl}/add-or-update-higher-national-diploma-application-education`;

export const addAndUpdateHigherDiplomaOlevel = () => `${baseUrl}/add-or-update-higher-national-diploma-application-olevel-details`;

export const getHigherNationalDiplomaReport = (filter) => `${baseUrl}/get-higher-national-diploma-application-report?${generateUrlParams(filter)}`;

export const downloadHigherNationalDiplomaReport = (filter) => `${baseUrl}/download-higher-national-diploma-application-report?${generateUrlParams(filter)}`;